export default "__VITE_ASSET__CDoeYLw7__"